import React, { FC } from 'react';
import { ProjectPhaseStatusChanged, StatusValue } from 'api/notifications/meta';
import { StatusIndicatorIcon } from 'components/molecules/status-indicator';
import { useExternalIntegrationUserDetails } from 'hooks/use-external-integration-user-details';
import { useTranslation } from 'hooks/use-translation';
import { Strong, Value } from '../basics';
import { FieldChangedMessage } from './field-changed';

const getStatusValue = ({ group, label }: StatusValue) => (
  <>
    <StatusIndicatorIcon group={group} />
    <Value>{label}</Value>
  </>
);

export const ProjectPhaseStatusChangedView: FC<{
  meta: ProjectPhaseStatusChanged;
}> = ({ meta: { phaseName, by, from, to, externalUser } }) => {
  const userDetails = useExternalIntegrationUserDetails(externalUser, by);

  return (
    <FieldChangedMessage
      name={useTranslation('fields.status')}
      by={userDetails}
      item={<Strong>{phaseName}</Strong>}
      from={getStatusValue(from)}
      to={getStatusValue(to)}
    />
  );
};
